import {
  z,
  uploadedFileBaseSchema,
  uploadStatusSchema,
  createUploadedFilesSchema,
  createFileUploadValidator,
} from '@tasama/utils';

export const newTicketUploadedFileSchema = uploadedFileBaseSchema;
export const NewTicketUploadStatusEnum = uploadStatusSchema;

export const newTicketUploadSchema = z.object({
  uploadedFiles: createUploadedFilesSchema({
    maxBytes: 5 * 1024 * 1024,
    allowedExts: ['pdf', 'png', 'jpg', 'jpeg'],
    minFiles: 0, // Files are optional for tickets
  }),
});

export type NewTicketUploadFormData = z.infer<typeof newTicketUploadSchema>;
export type NewTicketUploadedFile = z.infer<typeof newTicketUploadedFileSchema>;

export const newTicketUploadDefaultValues: NewTicketUploadFormData = {
  uploadedFiles: [],
};

export const validateNewTicketUploadForm = createFileUploadValidator(
  newTicketUploadSchema
);
